import {makeStyles} from '@material-ui/core/styles';

export const styles = makeStyles(() => ({
  textField: {
    width: '100%',
  },
  formattedDate: {
    marginTop: '8px',
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
}));
